import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items, tone = 'light' }: { items: Crumb[]; tone?: 'light' | 'dark' }) {
  const light = tone === 'light';
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              {item.to && !last ? (
                <Link
                  to={item.to}
                  className={light ? 'text-white/70 hover:text-white' : 'text-text-secondary hover:text-primary'}
                >
                  {item.label}
                </Link>
              ) : (
                <span className={light ? 'font-medium text-white' : 'font-medium text-text-primary'}>
                  {item.label}
                </span>
              )}
              {!last && <span className={light ? 'text-white/40' : 'text-ink/30'}>/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
